import React from "react";

//package import

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  DialogTitle,
} from "@mui/material";

//component

const DelModal = ({ status, open, handleClose, expiryNotificationHandler }) => {
  //hooks

  // render

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      // fullWidth={true}
      sx={{
        color: "gray",
        borderRadius: 2,
      }}
    >
      <DialogTitle sx={{ textAlign: "center" }}></DialogTitle>
  <DialogContent>
        <DialogContentText sx={{ textAlign: "center" }}>
          {status ? "Don't" : ""} Get Notified by Email?{" "}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ marginTop: 5, margin: "auto" }}>
        <Button
          onClick={handleClose}
          variant="contained"
          sx={{ borderRadius: 2 }}
        >
          No
        </Button>

        <Button
          variant="contained"
          onClick={(e) => {
            expiryNotificationHandler(status);
            handleClose(e);
          }}
          sx={{
            backgroundColor: "gray",
            borderRadius: 2,
          }}
          autoFocus
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DelModal;
